// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__20h9-","author":"Table_author__3zWqe","authorImage":"Table_authorImage__1jpu2","unreadRow":"Table_unreadRow__3G_Wl"};